const datas:any = 
[{ label: 'Opportunistic', value: 30 }, { label: 'Absolute Return', value: 25},{ label: 'Core Strategies', value: 45}];
export default datas;